// extracted by mini-css-extract-plugin
export default {"font_button_l":"font_button_l___r2XsS","font_button_m":"font_button_m___FcLGY","font_button_s":"font_button_s___vuoJy","faq":"faq___u7nCb","container":"container___EsfXH"};